var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:{
      'btn btn-outline-dark ': _vm.category === 'All',
      'btn btn-outline-danger ': _vm.category === 'Breakfast',
      'btn btn-outline-success ': _vm.category === 'Lunch',
      'btn btn-outline-warning': _vm.category === 'Dinner',
    },attrs:{"id":"category-button"},on:{"click":_vm.filterRecipes}},[_vm._v(" "+_vm._s(_vm.category)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }